import styled from "styled-components";

export const NotificationFooterDotContainer = styled.div`
  width: 3px;
  height: 3px;

  min-width: 3px;
  min-height: 3px;

  border-radius: 50%;

  background-color: ${({ theme }) => theme.notification.title};

  margin: 0 8px;
`;
